import { Outlet } from "react-router-dom";

export default function Standalone() {
  return (
    <div className="w-screen h-screen flex flex-column surface-100">
      <main className="flex flex-auto p-5 border-round overflow-auto">
        <Outlet/>
      </main>
    </div>
  );
}
